declare const __non_webpack_require__: typeof require;

/**
 * Get package information (name and version).
 *
 * In local monorepo consumption: imports from package.json
 * In built/released packages: imports from generated version.ts
 * Fallback: returns 'unavailable' if neither source is available
 */

type PackageInfo = { name: string; version: string };

// TODO fix this, once these issues are resolved https://atlassian.slack.com/archives/C0677M19GU9/p1769022376411909

// Try to import from package.json (works in monorepo with workspace:^)
// If that fails, try version.ts (generated during build)
// If both fail, use fallback
// let packageInfo: PackageInfo;

// try {
// 	// This static import works when consuming via workspace:^ in the monorepo
// 	// eslint-disable-next-line import/no-unresolved
// 	if (typeof __non_webpack_require__ !== 'undefined') {
// 		packageInfo = __non_webpack_require__('../../package.json');
// 	}

// } catch {
// 	try {
// 		// Try importing version.ts (auto-generated and committed to git)
// 		// This file is kept up-to-date by the ak-prebuild script
// 		// eslint-disable-next-line @typescript-eslint/no-var-requires
// 		const versionModule = __non_webpack_require__('../version');
// 		if (versionModule.packageInfo) {
// 			packageInfo = versionModule.packageInfo;
// 		} else {
// 			throw new Error('No packageInfo in version module');
// 		}
// 	} catch {
// 		// Both sources failed, use fallback
// 		packageInfo = {
// 			name: '@atlassian/conversation-assistant',
// 			version: 'unavailable',
// 		};
// 	}
// }

export function getPackageInfo(): PackageInfo {
	// return packageInfo;
	return {
		name: '@atlassian/conversation-assistant',
		version: 'unavailable',
	};
}
